import React from "react";

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;

interface ProposalFloorPlanProps {
    index: number;
    propertyDetails: any;
}


export default function ProposalFloorPlan({ index,
    propertyDetails }: ProposalFloorPlanProps) {
    return (
        <>
            {propertyDetails?.excludeFloorPlan === false &&
                propertyDetails.propertyFloorImage ? (
                <table
                    className="table-outer-area page-break"
                    style={{
                        // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
                        backgroundImage: `url(${proposalTableShadow})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        backgroundSize: "cover",
                        marginTop: "15px",
                        minHeight: "794px",
                    }}
                    width="100%"
                    cellPadding="10"
                    cellSpacing="0"
                >
                    <tbody>
                        <tr>
                            <td align="right">
                                <img width={110} src={logoIcon} alt="property image" />
                            </td>
                        </tr>

                        <tr>
                            <td
                                width="100%"
                                className="pl-40"
                                style={{
                                    color: "#021D77",
                                    marginTop: "-57px",
                                    display: "block",
                                }}
                            >
                                <span style={{ fontSize: "18px" }}>
                                    O P T I O N {index + 1}
                                </span>
                                <br />
                                <div style={{ display: "flex" }}>
                                    <strong
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: 700,
                                            maxWidth: "80%",
                                            flexShrink: 0,
                                        }}
                                    >
                                        {propertyDetails?.propertyName?.toUpperCase()}
                                    </strong>
                                    <div
                                        style={{
                                            height: "4px",
                                            width: "100%",
                                            backgroundColor: "#C39864",
                                            marginTop: "18px",
                                            marginLeft: "10px",
                                        }}
                                    ></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table cellPadding="0" cellSpacing="0" width="100%">
                                    <tbody>
                                        <tr>
                                            <td align="center">
                                                <table
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    width="950"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <table width="100%">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td
                                                                                style={{
                                                                                    marginBottom: "10px",
                                                                                    display: "block",
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "22px",
                                                                                        color: "#8FA9D4",
                                                                                        fontWeight: 700,
                                                                                    }}
                                                                                >
                                                                                    <u>
                                                                                        FLOOR PLAN:{" "}
                                                                                        {propertyDetails?.projectName?.toUpperCase()}
                                                                                        –{" "}
                                                                                        {propertyDetails?.floorOffered?.toUpperCase()}
                                                                                    </u>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td align="center">
                                                                                <img
                                                                                    className="floor-img"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        maxWidth: "800px",
                                                                                        objectFit: "contain",
                                                                                        maxHeight: "600px",
                                                                                        marginTop: "10px",
                                                                                    }}
                                                                                    // src={require(`../../../assets/images/proposal/floor-plan-4.png`)}
                                                                                    // src={floorPlan4}
                                                                                    src={
                                                                                        propertyDetails.propertyFloorImage
                                                                                    }
                                                                                    alt="property_image"
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td
                                style={{ backgroundColor: "#021D77" }}
                                height="50"
                                align="center"
                            ></td>
                        </tr>
                    </tbody>
                </table>
            ) : null}
        </>
    );
}
